import { useState } from "react";
import { FaRegSquare } from "react-icons/fa";
import { FaSquareCheck } from "react-icons/fa6";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch } from "react-redux";
import {
    InputField,
    Modal,
    PhoneInput,
    TextComponent
} from "../../../../components";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import styles from "./index.module.css";
import { CompanyMiddleware } from "../../../../Store/Middlewares/CompanyMiddleware";

const AddCustomer = ({ openModel, setopenModel }) => {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);

  const onCreateCustomer = () => {
    let userData = {
      firstName,
      lastName,
      email,
      contactNo,
      name,
      address
    };
    if (
      !firstName ||
      !lastName ||
      !email ||
      !contactNo ||
      !address
      // !name
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are required",
        })
      );
    } else {
      dispatch(CompanyMiddleware.createCustomer(userData)).then(() => {
        setopenModel(false);
        setIsSuccessFulModal(true);
        // getData();
      });
    }
  };

const onReset = () => {
    setName("");
    setAddress("");
    setEmail("");
    setFirstName("");
    setLastName("");
    setContactNo("");
  }

  return (
    <div>
      <Modal
        width={"600px"}
        open={openModel}
        onCancel={() => {
          setopenModel(false);
          onReset();
        }}
        twoButton
        okBtnTitle={"Save Information"}
        cancelBtnTitle={"Go Back"}
        onClickCancelButton={() => {
          setopenModel(false);
          onReset();
        }}
        onClickOkButton={onCreateCustomer}
      >
        <div className={styles.mainCont}>
          <TextComponent
            text={"Add Customer"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <TextComponent
            text={"Add Profile Information"}
            style={{ color: "var(--light-text)" }}
          />

         <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"First Name"}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder={"Write here..."}
              required
            />
            <InputField
              className={styles.input}
              label={"Last Name"}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder={"Write here..."}
              required
            //   disabled={true}
            />
          </div>

          <div className={styles.twoInput}>
            {/* <InputField
              className={styles.input}
              label={"Name"}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={"Write here..."}
            /> */}
            <InputField
              className={styles.input}
              label={"Email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={"Write here..."}
              type="email"
              required
            //   disabled={true}
            />
            <PhoneInput
              label={"Contact number"}
              placeholder={"(301) 580-7410"}
              className={styles.input}
              value={contactNo}
              onChange={setContactNo}
              required
            />
          </div>

          <div className={styles.twoInput}>
            <InputField
              className={styles.input}
              label={"Address"}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder={"Write here..."}
              style={{ width: "100%" }}
              required
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Changes saved"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => setIsSuccessFulModal(false)}
      ></Modal>
    </div>
  );
};

export default AddCustomer;
